export const players = [
  {
    id: 1,
    name: "محمد العويس",
    team: "الهلال",
    age: 19,
    position: "حارس مرمى",
    height: 188, // سم
    weight: 80, // كجم
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 92,
    matches: 15,
    cardsCount: 2,
    image: "/player1.jpg",
    attributes: [
      { name: "ردة الفعل", value: 90 },
      { name: "التصدي", value: 88 },
      { name: "الخروج", value: 85 },
    ],
    saves: 54,
    cleanSheets: 6,
    goalsConceded: 12,
    savesPerMatch: 3.6
  },
  {
    id: 2,
    name: "عبدالله المعيوف",
    team: "النصر",
    age: 20,
    position: "حارس مرمى",
    height: 185,
    weight: 78,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 88,
    matches: 18,
    cardsCount: 1,
    image: "/player2.jpg",
    attributes: [
      { name: "ردة الفعل", value: 85 },
      { name: "التصدي", value: 86 },
      { name: "الخروج", value: 87 },
    ],
    saves: 63,
    cleanSheets: 7,
    goalsConceded: 15,
    savesPerMatch: 3.5
  },
  {
    id: 3,
    name: "محمد السهلاوي",
    team: "النصر",
    age: 20,
    position: "مهاجم",
    height: 180,
    weight: 75,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 90,
    matches: 20,
    cardsCount: 4,
    image: "/player3.jpg",
    attributes: [
      { name: "التسديد", value: 90 },
      { name: "الحركة", value: 88 },
      { name: "المراوغة", value: 85 },
    ],
    goals: 14,
    assists: 5,
    passSuccessRate: 78,
    shotsPerMatch: 3.2,
    dribblesPerMatch: 2.1,
    keyPasses: 25,
    injuries: [
      {
        type: "إصابة في الركبة",
        description: "تمزق في الاربطة الجانبية",
        startDate: "2024-01-15",
        endDate: "2024-03-15",
        duration: "شهرين",
        recoveryStatus: "تعافى"
      }
    ]
  },
  {
    id: 4,
    name: "فواز القرني",
    team: "الاتحاد",
    age: 18,
    position: "مدافع",
    height: 182,
    weight: 76,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 85,
    matches: 14,
    cardsCount: 5,
    image: "/player4.jpg",
    attributes: [
      { name: "التمركز", value: 86 },
      { name: "التدخل", value: 85 },
      { name: "القوة", value: 84 },
    ],
    goals: 1,
    assists: 2,
    passSuccessRate: 83,
    tackles: 54,
    interceptions: 38,
    clearances: 42
  },
  {
    id: 5,
    name: "سالم الدوسري",
    team: "الهلال",
    age: 20,
    position: "جناح",
    height: 174,
    weight: 68,
    foot: "يسرى",
    nationality: "سعودي",
    successRate: 87,
    matches: 19,
    cardsCount: 3,
    image: "/player5.jpg",
    attributes: [
      { name: "السرعة", value: 90 },
      { name: "المراوغة", value: 89 },
      { name: "التمرير", value: 84 },
    ],
    goals: 8,
    assists: 11,
    passSuccessRate: 80,
    dribblesPerMatch: 4.3,
    keyPasses: 34
  },
  {
    id: 6,
    name: "ياسر الشهراني",
    team: "الهلال",
    age: 19,
    position: "ظهير أيسر",
    height: 170,
    weight: 65,
    foot: "يسرى",
    nationality: "سعودي",
    successRate: 89,
    matches: 17,
    cardsCount: 2,
    image: "/player6.jpg",
    attributes: [
      { name: "السرعة", value: 88 },
      { name: "التمرير", value: 87 },
      { name: "الدفاع", value: 85 },
    ],
    goals: 2,
    assists: 7,
    passSuccessRate: 85,
    tackles: 48,
    interceptions: 26,
    clearances: 31,
    dribblesPerMatch: 2.8,
    keyPasses: 29
  },
  {
    id: 7,
    name: "نواف العابد",
    team: "الهلال",
    age: 21,
    position: "وسط مهاجم",
    height: 176,
    weight: 70,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 86,
    matches: 16,
    cardsCount: 3,
    image: "/player7.jpg",
    attributes: [
      { name: "التمرير", value: 88 },
      { name: "الرؤية", value: 89 },
      { name: "التسديد", value: 83 },
    ],
    goals: 5,
    assists: 12,
    passSuccessRate: 89,
    dribblesPerMatch: 2.3,
    keyPasses: 32,
    shotsPerMatch: 1.8
  },
  {
    id: 8,
    name: "فهد المولد",
    team: "الاتحاد",
    age: 20,
    position: "ظهير أيمن",
    height: 175,
    weight: 72,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 84,
    matches: 18,
    cardsCount: 4,
    image: "/player8.jpg",
    attributes: [
      { name: "السرعة", value: 87 },
      { name: "التمرير", value: 83 },
      { name: "الدفاع", value: 80 },
    ],
    goals: 1,
    assists: 5,
    passSuccessRate: 81,
    tackles: 45,
    interceptions: 29,
    clearances: 36,
    dribblesPerMatch: 1.9
  },
  {
    id: 9,
    name: "عبدالفتاح آدم",
    team: "النصر",
    age: 18,
    position: "وسط دفاعي",
    height: 183,
    weight: 78,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 82,
    matches: 12,
    cardsCount: 6,
    image: "/player9.jpg",
    attributes: [
      { name: "الاعتراض", value: 85 },
      { name: "التمرير", value: 80 },
      { name: "القوة", value: 86 },
    ],
    goals: 0,
    assists: 2,
    passSuccessRate: 85,
    tackles: 52,
    interceptions: 41,
    clearances: 28
  },
  {
    id: 10,
    name: "حمدان الشمراني",
    team: "الاتحاد",
    age: 19,
    position: "جناح",
    height: 172,
    weight: 67,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 83,
    matches: 15,
    cardsCount: 2,
    image: "/player10.jpg",
    attributes: [
      { name: "السرعة", value: 89 },
      { name: "المراوغة", value: 84 },
      { name: "التمرير", value: 79 },
    ],
    goals: 6,
    assists: 7,
    passSuccessRate: 76,
    dribblesPerMatch: 3.8,
    keyPasses: 21
  },
  {
    id: 11,
    name: "عبدالله عطيف",
    team: "الهلال",
    age: 20,
    position: "وسط ارتكاز",
    height: 174,
    weight: 70,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 90,
    matches: 19,
    cardsCount: 4,
    image: "/player11.jpg",
    attributes: [
      { name: "التمرير", value: 91 },
      { name: "الرؤية", value: 87 },
      { name: "الاعتراض", value: 85 },
    ],
    goals: 3,
    assists: 8,
    passSuccessRate: 92,
    tackles: 35,
    interceptions: 42,
    keyPasses: 38,
    dribblesPerMatch: 1.5
  },
  {
    id: 12,
    name: "محمد كنو",
    team: "الهلال",
    age: 19,
    position: "وسط ميدان",
    height: 178,
    weight: 74,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 88,
    matches: 18,
    cardsCount: 3,
    image: "/player12.jpg",
    attributes: [
      { name: "التمرير", value: 88 },
      { name: "الاستحواذ", value: 87 },
      { name: "التسديد", value: 83 },
    ],
    goals: 7,
    assists: 9,
    passSuccessRate: 87,
    dribblesPerMatch: 1.7,
    keyPasses: 28,
    tackles: 31,
    interceptions: 23
  },
  {
    id: 13,
    name: "عبدالله الحمدان",
    team: "الشباب",
    age: 18,
    position: "مهاجم",
    height: 181,
    weight: 77,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 85,
    matches: 14,
    cardsCount: 2,
    image: "/player13.jpg",
    attributes: [
      { name: "التسديد", value: 87 },
      { name: "الالتحام", value: 82 },
      { name: "الحركة", value: 86 },
    ],
    goals: 11,
    assists: 3,
    passSuccessRate: 72,
    shotsPerMatch: 3.4,
    dribblesPerMatch: 2.2,
    keyPasses: 14
  },
  {
    id: 14,
    name: "سلطان الغنام",
    team: "الهلال",
    age: 20,
    position: "ظهير أيمن",
    height: 177,
    weight: 72,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 92,
    matches: 20,
    cardsCount: 3,
    image: "/player14.jpg",
    attributes: [
      { name: "السرعة", value: 92 },
      { name: "التمرير", value: 88 },
      { name: "الدفاع", value: 89 },
    ],
    goals: 3,
    assists: 8,
    passSuccessRate: 86,
    tackles: 64,
    interceptions: 35,
    clearances: 42,
    dribblesPerMatch: 2.5,
    injuries: [
      {
        type: "إصابة عضلية",
        description: "شد في العضلة الخلفية",
        startDate: "2024-02-20",
        endDate: null,
        duration: "3-4 أسابيع",
        recoveryStatus: "قيد التعافي"
      },
      {
        type: "التواء في الكاحل",
        description: "إصابة خفيفة في مباراة الدوري",
        startDate: "2023-11-10",
        endDate: "2023-11-25",
        duration: "أسبوعين",
        recoveryStatus: "تعافى"
      }
    ]
  },
  {
    id: 15,
    name: "عبدالرحمن غريب",
    team: "الأهلي",
    age: 19,
    position: "وسط مهاجم",
    height: 173,
    weight: 68,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 89,
    matches: 17,
    cardsCount: 1,
    image: "/player15.jpg",
    attributes: [
      { name: "المراوغة", value: 90 },
      { name: "التمرير", value: 88 },
      { name: "التسديد", value: 85 },
    ],
    goals: 9,
    assists: 13,
    passSuccessRate: 84,
    dribblesPerMatch: 3.5,
    keyPasses: 37,
    shotsPerMatch: 2.3
  },
  {
    id: 16,
    name: "محمد البريك",
    team: "الهلال",
    age: 20,
    position: "ظهير أيمن",
    height: 175,
    weight: 70,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 87,
    matches: 16,
    cardsCount: 2,
    image: "/player16.jpg",
    attributes: [
      { name: "السرعة", value: 88 },
      { name: "التمرير", value: 85 },
      { name: "الدفاع", value: 87 },
    ],
    goals: 2,
    assists: 6,
    passSuccessRate: 82,
    tackles: 49,
    interceptions: 31,
    clearances: 38,
    dribblesPerMatch: 2.1
  },
  {
    id: 17,
    name: "عبدالإله المالكي",
    team: "الاتحاد",
    age: 19,
    position: "وسط دفاعي",
    height: 180,
    weight: 76,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 86,
    matches: 15,
    cardsCount: 5,
    image: "/player17.jpg",
    attributes: [
      { name: "الاعتراض", value: 87 },
      { name: "التمرير", value: 84 },
      { name: "القوة", value: 89 },
    ],
    goals: 1,
    assists: 4,
    passSuccessRate: 88,
    tackles: 47,
    interceptions: 45,
    clearances: 34
  },
  {
    id: 18,
    name: "فراس البريكان",
    team: "النصر",
    age: 21,
    position: "مهاجم",
    height: 184,
    weight: 79,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 84,
    matches: 18,
    cardsCount: 1,
    image: "/player18.jpg",
    attributes: [
      { name: "التسديد", value: 87 },
      { name: "الحركة", value: 84 },
      { name: "القوة", value: 83 },
    ],
    goals: 12,
    assists: 2,
    passSuccessRate: 74,
    shotsPerMatch: 3.3,
    dribblesPerMatch: 1.9,
    keyPasses: 11
  },
  {
    id: 19,
    name: "سعود عبدالحميد",
    team: "الشباب",
    age: 19,
    position: "مدافع وسط",
    height: 186,
    weight: 82,
    foot: "يسرى",
    nationality: "سعودي",
    successRate: 83,
    matches: 14,
    cardsCount: 4,
    image: "/player19.jpg",
    attributes: [
      { name: "الالتحام", value: 86 },
      { name: "التمركز", value: 84 },
      { name: "القوة", value: 88 },
    ],
    goals: 0,
    assists: 1,
    passSuccessRate: 79,
    tackles: 51,
    interceptions: 43,
    clearances: 56
  },
  {
    id: 20,
    name: "عبدالله الخيبري",
    team: "الهلال",
    age: 21,
    position: "وسط دفاعي",
    height: 179,
    weight: 75,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 85,
    matches: 19,
    cardsCount: 5,
    image: "/player20.jpg",
    attributes: [
      { name: "الاعتراض", value: 86 },
      { name: "التمرير", value: 85 },
      { name: "الرؤية", value: 82 },
    ],
    goals: 2,
    assists: 5,
    passSuccessRate: 89,
    tackles: 55,
    interceptions: 48,
    clearances: 32
  },
  {
    id: 21,
    name: "يوسف الجبلي",
    team: "الاتفاق",
    age: 17,
    position: "جناح",
    height: 171,
    weight: 65,
    foot: "يسرى",
    nationality: "سعودي",
    successRate: 86,
    matches: 12,
    cardsCount: 1,
    image: "/player21.jpg",
    attributes: [
      { name: "السرعة", value: 91 },
      { name: "المراوغة", value: 88 },
      { name: "التمرير", value: 81 },
    ],
    goals: 5,
    assists: 8,
    passSuccessRate: 78,
    dribblesPerMatch: 4.1,
    keyPasses: 23
  },
  {
    id: 22,
    name: "عمر المحيميد",
    team: "الأهلي",
    age: 18,
    position: "وسط مهاجم",
    height: 175,
    weight: 68,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 83,
    matches: 13,
    cardsCount: 2,
    image: "/player22.jpg",
    attributes: [
      { name: "التمرير", value: 85 },
      { name: "الرؤية", value: 87 },
      { name: "التسديد", value: 82 },
    ],
    goals: 6,
    assists: 7,
    passSuccessRate: 82,
    dribblesPerMatch: 2.4,
    keyPasses: 27,
    shotsPerMatch: 1.6
  },
  {
    id: 23,
    name: "فيصل الغامدي",
    team: "الاتحاد",
    age: 19,
    position: "مدافع",
    height: 185,
    weight: 80,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 88,
    matches: 16,
    cardsCount: 3,
    image: "/player23.jpg",
    attributes: [
      { name: "التمركز", value: 88 },
      { name: "التدخل", value: 89 },
      { name: "القوة", value: 87 },
    ],
    goals: 1,
    assists: 0,
    passSuccessRate: 80,
    tackles: 59,
    interceptions: 44,
    clearances: 51
  },
  {
    id: 24,
    name: "محمد القحطاني",
    team: "النصر",
    age: 20,
    position: "مهاجم",
    height: 182,
    weight: 76,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 89,
    matches: 18,
    cardsCount: 0,
    image: "/player24.jpg",
    attributes: [
      { name: "التسديد", value: 92 },
      { name: "الحركة", value: 87 },
      { name: "المراوغة", value: 86 },
    ],
    goals: 16,
    assists: 4,
    passSuccessRate: 75,
    shotsPerMatch: 3.8,
    dribblesPerMatch: 2.5,
    keyPasses: 18
  },
  {
    id: 25,
    name: "تركي العماري",
    team: "الرائد",
    age: 19,
    position: "وسط ميدان",
    height: 177,
    weight: 72,
    foot: "يمنى",
    nationality: "سعودي",
    successRate: 82,
    matches: 15,
    cardsCount: 4,
    image: "/player25.jpg",
    attributes: [
      { name: "التمرير", value: 84 },
      { name: "الاستحواذ", value: 81 },
      { name: "الرؤية", value: 85 },
    ],
    goals: 4,
    assists: 6,
    passSuccessRate: 83,
    dribblesPerMatch: 2.1,
    keyPasses: 22,
    tackles: 33,
    interceptions: 25
  }
]; 